import {
  DEFAULT_SELECTED_PAGE,
  DEFAULT_SELECTED_PAGE_SIZE,
} from "../../../constants";

const SET_USERS_LIST = "SET_USERS_LIST";
const SET_USERS_LIST_FILTERS = "SET_USERS_LIST_FILTERS";
const SET_USERS_LIST_LOADING = "SET_USERS_LIST_LOADING";

const initialUsersListState = {
  data: undefined,
  loading: null,
  filters: {
    selectedPage: DEFAULT_SELECTED_PAGE,
    selectedPageSize: DEFAULT_SELECTED_PAGE_SIZE,
    searchValue: "",
    deletedOnly: false,
  },
  total: undefined,
};

const setUsersListLoading = (payload) => ({
  type: SET_USERS_LIST_LOADING,
  payload,
});

const setUsersList = (payload) => ({
  type: SET_USERS_LIST,
  payload,
});

const setUsersListFilters = (payload = undefined) => ({
  type: SET_USERS_LIST_FILTERS,
  payload,
});

export {
  initialUsersListState,
  setUsersListLoading,
  setUsersList,
  setUsersListFilters,
  SET_USERS_LIST,
  SET_USERS_LIST_FILTERS,
  SET_USERS_LIST_LOADING,
};

